export const PaymentGatewayTypes = {
    ZARINPAL : {
        id:"ZARINPAL",
        name:"زرین پال"
    },
}